// packages/components/src/support-ai/ConversationHub.tsx
import React from 'react';
import { ChatConsole } from '../ChatConsole'; // Reusing the now-flexible ChatConsole

// Minimal shape for a chat message
interface ChatMessage {
  id: string;
  type: 'user' | 'assistant' | 'tool_response';
  text?: string;
}

interface ConversationHubProps<T extends ChatMessage> {
  chatHistory: T[];
  isThinking: boolean;
  onSendMessage: (message: string) => void;
  onActionClick: (actionId: string) => void;
  header?: React.ReactNode;
  
  // --- FIX: Add the new props that need to be passed through ---
  chatMode: 'customer' | 'ai';
  onChatModeChange: (mode: 'customer' | 'ai') => void;
  onFileUpload: (files: File[]) => void;
}

export const ConversationHub = <T extends ChatMessage>({
  chatHistory,
  isThinking,
  onSendMessage,
  onActionClick,
  header,
  // --- FIX: Destructure the new props ---
  chatMode,
  onChatModeChange,
  onFileUpload,
}: ConversationHubProps<T>) => {
  return (
    <div className="h-full flex flex-col bg-white">
        <ChatConsole
            chatHistory={chatHistory as any}
            onSendMessage={onSendMessage}
            isSending={isThinking}
            onActionClick={onActionClick}
            header={header}
            // --- FIX: Pass the new props down to the ChatConsole component ---
            chatMode={chatMode}
            onChatModeChange={onChatModeChange}
            onFileUpload={onFileUpload}
        />
    </div>
  );
};